import { useEffect, useState } from "react";
import { api, dispDate, todayYMD } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Loader2, Plus, Trash2 } from "lucide-react";
import { PageLoader } from "@/components/PageLoader";

export default function AdminMultiplier() {
  const [users, setUsers] = useState([]);
  const [list, setList] = useState([]);
  const [userId, setUserId] = useState("");
  const [date, setDate] = useState(todayYMD());
  const [mult, setMult] = useState(2);
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = () => api.get("/multipliers").then((r) => setList(r.data));
  useEffect(() => {
    Promise.all([
      api.get("/users").then((r) => setUsers(r.data.filter((u) => u.role === "pegawai"))),
      refresh(),
    ]).finally(() => setLoading(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!userId) return toast.error("Pilih pegawai");
    setBusy(true);
    try {
      await api.post("/multipliers", { user_id: userId, work_date: date, multiplier: parseFloat(mult) });
      toast.success("Tersimpan");
      refresh();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); }
    finally { setBusy(false); }
  };

  const del = async (m) => {
    if (!window.confirm("Hapus?")) return;
    await api.delete(`/multipliers/${m.id}`);
    refresh();
  };

  const umap = Object.fromEntries(users.map((u) => [u.id, u]));

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 max-w-5xl mx-auto">
      <p className="overline">Lembur</p>
      <h1 className="font-display text-3xl font-bold tracking-tight">Multiplier Lembur</h1>

      {loading ? <PageLoader label="Memuat data multiplier..." /> : (<>
      <Card className="mt-6 p-6 border border-zinc-200 shadow-none">
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
          <div>
            <Label>Pegawai</Label>
            <Select value={userId} onValueChange={setUserId}>
              <SelectTrigger className="mt-1" data-testid="mult-user"><SelectValue placeholder="Pilih" /></SelectTrigger>
              <SelectContent>{users.map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Tanggal</Label>
            <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mt-1" data-testid="mult-date" />
          </div>
          <div>
            <Label>Multiplier</Label>
            <Input type="number" step="0.1" value={mult} onChange={(e) => setMult(e.target.value)} className="mt-1" data-testid="mult-val" />
          </div>
          <Button type="submit" disabled={busy} className="bg-primary hover:bg-primary/90" data-testid="btn-save-mult">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Plus className="w-4 h-4 mr-1.5" />Simpan</>}
          </Button>
        </form>
      </Card>

      <div className="mt-6 space-y-2">
        {list.map((m) => (
          <Card key={m.id || `${m.user_id}-${m.work_date}`} className="p-3 border border-zinc-200 shadow-none flex justify-between items-center">
            <div>
              <p className="font-semibold">{umap[m.user_id]?.name || m.user_id}</p>
              <p className="text-xs text-zinc-500">{dispDate(m.work_date)} · ×{m.multiplier}</p>
            </div>
            <Button variant="ghost" size="icon" onClick={() => del(m)}>
              <Trash2 className="w-4 h-4 text-red-600" />
            </Button>
          </Card>
        ))}
      </div>
      </>)}
    </div>
  );
}
